import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Layout, Typography, Row, Col, Form, Input, Button } from "antd";
import LogoImg from "../assets/images/teamonelogo.png";
import BackgroundImg from "../assets/images/team-as-one-forbannser.svg";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Loader from "../components/Loader";

const { Title } = Typography;
const { Content } = Layout;

const ResetPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { request } = useRequest();

  const adminId = searchParams.get("adminId");

  const onFinish = (values) => {
    const { newPassword, confirmPassword } = values;

    if (!adminId) {
      ShowToast("Missing adminId in URL", Severty.ERROR);
      return;
    }

    if (newPassword !== confirmPassword) {
      ShowToast("Passwords do not match", Severty.ERROR);
      return;
    }

    const payload = {
      adminId,
      password: newPassword,
    };

    setLoading(true);

    request({
      url: "/admin/auth/reset-password",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        ShowToast(data.message || "Password reset successful", Severty.SUCCESS);
        navigate("/login");
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.message || "Failed to reset password", Severty.ERROR);
      },
    });
  };

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Row className="align-items-center layout-signin-rowsss">
          {loading && <Loader />}

          <Col span={24} lg={7} className="">
            <Content className="signin">
              <div className="signin-box">
                <div className="signup-logo">
                  <img src={LogoImg} />
                  <h4>Reset Password</h4>
                </div>
                <Row justify="space-around">
                  <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                    <div className="signup-form">
                      {/* <Title className="mb-15">Sign In</Title>
                      <Title className="font-regular text-muted" level={5}>
                        Enter your email and password to sign in
                      </Title> */}
                      <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        style={{ marginTop: 30 }}
                      >
                        <Form.Item
                          name="newPassword"
                          label="New Password"
                          rules={[
                            {
                              required: true,
                              message: "Please enter your new password",
                            },
                            {
                              validator: (_, value) => {
                                if (!value || value.trim() === "") {
                                  return Promise.reject(
                                    new Error("Password cannot be only spaces")
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                            {
                              pattern:
                                /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d@$!%*?&^#_~\-]{8,}$/,
                              message:
                                "Password must be at least 8 characters, include letters, numbers, and can contain special characters",
                            },
                          ]}
                          style={{ textWrap: "auto" }}
                        >
                          <Input.Password placeholder="New password" />
                        </Form.Item>

                        <Form.Item
                          name="confirmPassword"
                          label="Confirm Password"
                          dependencies={["newPassword"]}
                          rules={[
                            {
                              required: true,
                              message: "Please confirm your password!",
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  getFieldValue("newPassword") === value
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error("Passwords do not match!")
                                );
                              },
                            }),
                          ]}
                        >
                          <Input.Password placeholder="Confirm password" />
                        </Form.Item>

                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            block
                            loading={loading}
                          >
                            Reset Password
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </Col>
                  {/* <Col
                className="sign-img"
                style={{ padding: 12 }}
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                md={{ span: 12 }}
              >
                <img src={signinbg} alt="" />
              </Col> */}
                </Row>
              </div>
            </Content>
          </Col>
          <Col span={24} lg={17} className="signin-bg">
            <div className="signin-bg-image">
              <img src={BackgroundImg} />
            </div>
          </Col>
        </Row>
      </Layout>
    </>
  );
};

export default ResetPassword;
